import React, {useContext} from 'react'
import {Organization} from '../../model/Organization'
import {DisplaySetTreeComponent} from '../../../displaySet/DisplaySetTreeComponent'
import {DisplaySetContext} from '../../../displaySet/DisplaySetContext'

export const OrganizationDetailsContent = ({organization}: {
    organization: Organization,
}) => {
    const {selectedDisplaySet} = useContext(DisplaySetContext)

    return <div className="organization-details-content details-content details-page-section">
        <div className="display-sets">{selectedDisplaySet &&
                <DisplaySetTreeComponent
                    key={selectedDisplaySet?.displayOrder ?? Math.random()}
                    displaySet={selectedDisplaySet}
                />
            }
        </div>
    </div>
}
